import { useTranslation } from "react-i18next";

const BrowserSourceStateDisplayComponent = ({ browserSourceIsActive }) => {
    const { t } = useTranslation("settings");
    const display = (
        <>
            <h3>{t("browserSourceTitle")}</h3>
            <p className="settingsDescription">
                {t("browserSourceDescription")}
            </p>
            <h3
                className={
                    browserSourceIsActive
                        ? "ActiveTextDisplaySettingsContent"
                        : "testMemeMessageText"
                }
            >
                {browserSourceIsActive
                    ? t("browserSourceActive")
                    : t("browserSourceInactive")}
            </h3>
            <p className="settingsDescription">
                {t("browserSourceSettingsDescription")}
            </p>
        </>
    );

    return display;
};

export default BrowserSourceStateDisplayComponent;
